export const filterIds = ['country', 'feature'] as const;
